module.exports = __webpack_public_path__ + "img/sol_cap2.af239168.png";